import { openDB } from "idb";

const DB_NAME = "sgdinnerlocal";
const DB_VERSION = 1; // Cambia si necesitas actualizar la estructura

// 📌 Inicializar o actualizar la base de datos dinámicamente
/* export async function initDB(storeName, indexes = []) {
  return openDB(DB_NAME, DB_VERSION, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(storeName)) {
        const store = db.createObjectStore(storeName, {
          keyPath: "id",
          autoIncrement: true,
        });

        // Crear índices si se proporcionan
        indexes.forEach((index) => {
          if (!store.indexNames.contains(index.name)) {
            store.createIndex(index.name, index.key, { unique: index.unique });
          }
        });

        console.log(
          `✅ Almacén "${storeName}" creado con índices: ${indexes
            .map((i) => i.name)
            .join(", ")}`
        );
      }
    },
  });
} */

  export async function initDB() {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open("ticketsdb", 2); // Base de datos única
  
      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        const stores = ["usuarios", "periodo","tickets"]; // Lista de almacenes permitidos
  
        stores.forEach((storeName) => {
          if (!db.objectStoreNames.contains(storeName)) {
            db.createObjectStore(storeName, { keyPath: "id" });
          }
        });
      };
  
      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject(request.error);
    });
  }
// 📌 Guardar o actualizar registros en IndexedDB
export async function saveData(storeName, dataArray, indexKey = null) {
  const db = await initDB(storeName);
  const tx = db.transaction(storeName, "readwrite");
  const store = tx.objectStore(storeName);

  for (const item of dataArray) {
    let exists = false;

    if (indexKey && store.indexNames.contains(indexKey)) {
      const index = store.index(indexKey);
      exists = await index.get(item[indexKey]); // 📌 Buscar si ya existe
    } else {
      const allData = await store.getAll();
      exists = allData.find((entry) => entry[indexKey] === item[indexKey]); // 📌 Buscar manualmente
    }

    if (exists) {
      await store.put(item); // 🔄 Actualizar si ya existe
      console.log(`🔄 Registro actualizado: ${JSON.stringify(item)}`);
    } else {
      await store.add(item); // ✅ Insertar si no existe
      console.log(`✅ Registro agregado: ${JSON.stringify(item)}`);
    }
  }

  await tx.done;
  return;
}

export async function saveOrUpdateArray(storeName, key, newDataArray) {
  try {
    const db = await initDB(storeName);
    const tx = db.transaction(storeName, "readwrite");
    const store = tx.objectStore(storeName);

    // 📌 Intentar obtener el registro existente
    const existingRecord = await store.get(key);

    if (existingRecord) {
      // ✅ Si existe, actualiza los datos sin duplicar
      console.log(`🔄 Actualizando datos en IndexedDB con clave "${key}"`);
      await store.put({ id: key, data: [...newDataArray] });
    } else {
      // ✅ Si no existe, lo crea
      console.log(`🆕 Creando nuevo registro en IndexedDB con clave "${key}"`);
      await store.add({ id: key, data: [...newDataArray] });
    }

    await tx.done;
    return { success: true, message: "Datos guardados correctamente." };
  } catch (error) {
    return { success: false, message: error.message };
  }
}

export async function removeDuplicates(storeName, indexKey) {
  const db = await initDB(storeName);
  const tx = db.transaction(storeName, "readwrite");
  const store = tx.objectStore(storeName);

  const allData = await store.getAll();
  const seen = new Set();

  for (const item of allData) {
    if (seen.has(item[indexKey])) {
      await store.delete(item.id); // 📌 Eliminar duplicados
      console.log(`🗑️ Eliminado duplicado: ${JSON.stringify(item)}`);
    } else {
      seen.add(item[indexKey]);
    }
  }

  await tx.done;
  console.log(`✅ Duplicados eliminados en '${storeName}'.`);
}

export async function checkDuplicates(storeName, indexKey) {
  const db = await initDB(storeName);
  const tx = db.transaction(storeName, "readonly");
  const store = tx.objectStore(storeName);

  if (!store.indexNames.contains(indexKey)) {
    console.log(`ℹ️ No hay índice '${indexKey}' en '${storeName}'.`);
    return [];
  }

  const allData = await store.getAll();
  const seen = new Set();
  const duplicates = allData.filter((item) => {
    if (seen.has(item[indexKey])) return true;
    seen.add(item[indexKey]);
    return false;
  });

  console.log(
    `🔍 Duplicados encontrados en '${storeName}' para '${indexKey}':`,
    duplicates
  );
  return duplicates;
}

// 📌 Obtener todos los registros de un almacén
export async function getData(storeName) {
  try {
    const db = await initDB(); // Conectar a la base de datos
    const tx = db.transaction(storeName, "readonly");
    const store = tx.objectStore(storeName);

    // Envuelve el request en una promesa
    const request = store.get(1);
    
    const data = await new Promise((resolve, reject) => {
      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject(request.error);
    });

    if (!data) {
      return { success: false, message: `No se encontró ningún dato con la clave "${1}".`, data: null };
    }

    return { success: true, message: "ok", data:request.result ,code:"getdata"};
  } catch (e) {
    return { success: false, message: e.message, data: [],code:e.code };
  }
}

// 📌 Buscar un registro específico por índice o ID
export async function getDataByKey(storeName, key, value) {
  const db = await initDB(storeName);
  const store = db.transaction(storeName, "readonly").objectStore(storeName);

  if (store.indexNames.contains(key)) {
    return store.index(key).get(value); // 📌 Buscar por índice
  } else {
    const allData = await store.getAll();
    return allData.find((item) => item[key] === value); // 📌 Buscar manualmente
  }
}
